export default __webpack_public_path__ + "static/media/firstcard.7449fd9b.jpg";